"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyEntityType = void 0;
var CompanyEntityType;
(function (CompanyEntityType) {
    CompanyEntityType["C_CORPORATION"] = "C-Corp (Form 1120)";
    CompanyEntityType["B_CORPORATION"] = "B-Corp (Form 1120)";
    CompanyEntityType["S_CORPORATION"] = "S-Corp (Form 1120-S)";
    CompanyEntityType["PARTNERSHIP"] = "Partnership (Form 1065)";
    CompanyEntityType["LLC_AS_C_CORPORATION"] = "LLC taxed as C-Corp (Form 1120)";
    CompanyEntityType["LLC_AS_S_CORPORATION"] = "LLC taxed as S-Corp (Form 1120-S)";
    CompanyEntityType["LLC_AS_PARTNERSHIP"] = "LLC taxed as Partnership (Form 1065)";
    CompanyEntityType["LLC_AS_SOLE_PROPRIETORSHIP"] = "LLC taxed as Sole Proprietorship";
})(CompanyEntityType || (exports.CompanyEntityType = CompanyEntityType = {}));
